_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ "89Ff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("iuhU");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("TmFx");
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_5__);





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Button = /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["memo"])( /*#__PURE__*/Object(react__WEBPACK_IMPORTED_MODULE_4__["forwardRef"])(function (_ref, ref) {
  var _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'button' : _ref$as,
      icon = _ref.icon,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$iconPosition = _ref.iconPosition,
      iconPosition = _ref$iconPosition === void 0 ? 'left' : _ref$iconPosition,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["as", "icon", "children", "className", "iconPosition"]);

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(As, _objectSpread(_objectSpread({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.button, className, iconPosition === 'right' && _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonIconRight, props.disabled && _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.buttonDisabled) // @ts-ignore
    ,
    ref: ref
  }, props), {}, {
    children: [icon && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])("span", {
      className: Object(clsx__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(icon, children && _button_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a.icon)
    }), children]
  }));
}));
Button.displayName = 'Button';

/***/ }),

/***/ "CGYe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ AboutPage; });

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__("89Ff");

// EXTERNAL MODULE: ./components/AboutSection/aboutSection.module.scss
var aboutSection_module = __webpack_require__("dhpC");
var aboutSection_module_default = /*#__PURE__*/__webpack_require__.n(aboutSection_module);

// CONCATENATED MODULE: ./components/AboutSection/AboutSection.tsx





var AboutSection_AboutSection = function AboutSection() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("section", {
    className: aboutSection_module_default.a.section,
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h2", {
      className: aboutSection_module_default.a.heading,
      children: "O serwisie"
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
      className: aboutSection_module_default.a.buttons,
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
        href: "/",
        passHref: true,
        children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* Button */], {
          icon: "icon-arrow-left2",
          children: "Strona G\u0142\xF3wna"
        })
      })
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("article", {
      className: aboutSection_module_default.a.note,
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h3", {
        children: "Po co jest ten serwis?"
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
        children: ["Serwis ", /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "Polski Frontend"
        }), " powsta\u0142 w celu zebrania w jednym miejscu jak najwi\u0119kszej liczby stron, serwis\xF3w oraz blog\xF3w na temat szeroko rozumianego frontend developmentu. Co wa\u017Cne, wszystkie zgromadzone tutaj serwisy tworzone s\u0105", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "w j\u0119zyku polskim"
        }), "!"]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
        children: ["Podstawowym za\u0142o\u017Ceniem \"Polskiego Frontendu\" by\u0142o zebranie tutaj", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "ca\u0142ych blog\xF3w"
        }), ", a nie pojedynczych artyku\u0142\xF3w. Z tego powodu selekcji tre\u015Bci mog\u0119 dokonywa\u0107 jedynie na etapie dodawania danej strony do serwisu. Jako, \u017Ce nie ka\u017Cdy pisze tylko i wy\u0142\u0105cznie o frontendzie, to czasem mo\u017Ce si\u0119 tutaj pojawi\u0107 wpis na temat, na przyk\u0142ad, PHP... Wydaje mi si\u0119 jednak, \u017Ce ka\u017Cdy blog czy strona, kt\xF3ra pisze", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "du\u017Co o frontendzie, czy og\xF3lniej o web developmencie"
        }), ", zas\u0142uguje by si\u0119 tutaj znale\u017A\u0107... Nawet je\u015Bli frontend to nie jedyny poruszany tam temat."]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
        children: ["Je\u017Celi wi\u0119c znasz (lub sam prowadzisz) jaki\u015B blog, serwis lub stron\u0119", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "w j\u0119zyku polskim"
        }), ", kt\xF3rej tutaj nie ma, a uwa\u017Casz, \u017Ce powinna si\u0119 tu znale\u017A\u0107 - zapraszam do zg\u0142oszenia go przez specjalnie do tego celu", ' ', /*#__PURE__*/Object(jsx_runtime["jsx"])(link_default.a, {
          href: "/zglos-serwis",
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
            children: "przygotowany formularz"
          })
        }), ". Obiecuj\u0119, \u017Ce przejrz\u0119 ka\u017Cde zg\u0142oszenie i je\u015Bli uznam, \u017Ce dana strona si\u0119 nadaje - dodam j\u0105 do serwisu!"]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
        children: ["A je\u015Bli podoba Ci si\u0119 moja idea i sam prowadzisz bloga o frontendzie, to opr\xF3cz zg\u0142oszenia zach\u0119cam r\xF3wnie\u017C, do ", /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "polecania tej strony"
        }), " swoim czytelnikom! Im wi\u0119kszy ruch tutaj ", /*#__PURE__*/Object(jsx_runtime["jsx"])("strong", {
          children: "tym wi\u0119kszy ruch do Twojego bloga..."
        })]
      })]
    })]
  });
};
AboutSection_AboutSection.displayName = 'AboutSection';
// EXTERNAL MODULE: ./components/Layout.tsx + 4 modules
var Layout = __webpack_require__("apO0");

// CONCATENATED MODULE: ./pages/o-serwisie.tsx



function AboutPage() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(Layout["a" /* Layout */], {
    title: "O serwisie",
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(AboutSection_AboutSection, {})
  });
}

/***/ }),

/***/ "Ff2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _objectWithoutProperties; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "NJwG":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-serwisie",
      function () {
        return __webpack_require__("CGYe");
      }
    ]);
  

/***/ }),

/***/ "TmFx":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__58Y2e","buttonIconRight":"button_buttonIconRight__1aVop","icon":"button_icon__1D0K9","buttonDisabled":"button_buttonDisabled__1L1QL"};

/***/ }),

/***/ "dhpC":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"aboutSection_section__3BWCt","heading":"aboutSection_heading__3CLEM","buttons":"aboutSection_buttons__2RbZo","note":"aboutSection_note__27-yM"};

/***/ }),

/***/ "iuhU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ })

},[["NJwG",1,0,2,4,3,5,6]]]);